import { Box, SxProps, Theme, Typography, useTheme } from '@mui/material';
import React from 'react';

interface IProps {
  label: string;
  children?: React.ReactNode;
  sx?: SxProps<Theme>;
}

export const FormLabel = ({ label, children, sx }: IProps) => {
  const theme = useTheme();
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', width: '100%', ...sx }}>
      <Typography variant="body2" fontWeight={theme.typography.fontWeightMedium} sx={{ lineHeight: 1.57, py: 1.5 }}>
        {label}
      </Typography>
      {children}
    </Box>
  );
};
